import React from "react";
import "../../../styles/colors.scss";
import { Tooltip } from "primereact/tooltip";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";

export const formatNumber = (value) => {
  return value !== null && value !== undefined ? value.toLocaleString() : "--";
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date
    .toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .replace(/,/, "");
};

export const formatTo12Hour = (dateString) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid Date"; // Return a placeholder for invalid date
  }

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true, // 12-hour format
  };
  const formattedDate = date.toLocaleString("en-US", options);
  return formattedDate;
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatCapitalizeFirstLetter = (rowData, field) => {
  if (!rowData || rowData[field] === undefined || rowData[field] === null) {
    return "";
  }

  return capitalizeFirstLetter(rowData[field]);
};

export const statusColors = (rowData) => {
  let color;
  switch (rowData.status || rowData.periorty) {
    case "pending":
    case "Pending":
    case "medium":
      color = "var(--pending-color)";
      break;
    case "rejected":
      color = "#F40000";
      break;
    case "active":
    case "Resolved":
    case "high":
      color = "var(--active-color)";
      break;
    case "In-Process":
    case "low":
      color = "var(--inprocess-color)";
      break;
    default:
      color = "var(--black-color)";
      break;
  }
  return (
    <span style={{ color }}>
      {formatCapitalizeFirstLetter(rowData, "status")}
      {formatCapitalizeFirstLetter(rowData, "periorty")}
    </span>
  );
};

const hasModulePermission = (permissions, module, action) => {
  return permissions?.[module]?.[action] || false;
};

export default hasModulePermission;

export const renderTextWithTooltip = (
  rowData,
  field,
  tooltipPosition = "bottom"
) => {
  const capitalizedDescription = formatCapitalizeFirstLetter(rowData, field);

  if (!capitalizedDescription) {
    return "--";
  }

  const truncatedDescription = capitalizedDescription.slice(0, 14);
  const remainingDescription = capitalizedDescription.slice(14);

  return (
    <div
      className="hoverable-description"
      data-pr-tooltip={capitalizedDescription}
      data-pr-position={tooltipPosition}
      data-pr-tooltip-options={{
        position: tooltipPosition,
        mouseTrack: true,
        mouseTrackTop: 15,
      }}
    >
      {truncatedDescription}
      {remainingDescription && <span>...</span>}
      <Tooltip
        target=".hoverable-description"
        style={{
          maxWidth: "300px",
          whiteSpace: "nowrap",
          wordWrap: "break-word",
        }}
      />
    </div>
  );
};

export const exportToExcel = (data, columns, fileName = "ExportedData") => {
  if (!Array.isArray(data) || data.length === 0) {
    toast.warn("No data available to export.");
    return;
  }

  const hiddenColumns = ["Action", "Assign", "Resolve"];
  const exportableColumns = columns.filter((col) => !hiddenColumns.includes(col.header));
    const headers = exportableColumns.map((col) => col.header);
  const fields = exportableColumns.map((col) => col.field);

  const formattedData = data.map((item) =>
    Object.fromEntries(fields.map((field) => [field, item[field] || "--"]))
  );

  if (!headers.length || !formattedData.length) {
    toast.error("Data processing error.");
    return;
  }

  const worksheet = XLSX.utils.json_to_sheet([]);
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
  XLSX.utils.sheet_add_json(worksheet, formattedData, {
    origin: "A2",
    skipHeader: true,
  });

  worksheet["!cols"] = fields.map(() => ({ wpx: 120 }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
  XLSX.writeFile(workbook, `${fileName}.xlsx`);

  toast.success("Excel file exported successfully!");
};
